import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

/* ── Theme ─────────────────────────────────────────────────── */
const GOLD        = '#C9952A';
const GOLD_LIGHT  = '#E8B84B';
const CREAM       = '#FAF6ED';
const TEXT_DARK   = '#2A1F0E';

const HeaderContainer = styled.header`
  background: rgba(250, 246, 237, 0.96);
  box-shadow: 0 2px 16px rgba(201, 149, 42, 0.13);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(201, 149, 42, 0.18);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 24px rgba(201, 149, 42, 0.2);
  }

  @media (max-width: 768px) {
    padding: 0.5rem 1rem;
  }
`;

const Nav = styled.nav`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.4rem 2rem;

  @media (max-width: 768px) {
    position: relative;
    padding: 0.4rem 1rem;
  }
`;

const Logo = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  padding: 0.4rem 0;

  img {
    height: 56px;
    width: auto;
    transition: transform 0.3s ease, filter 0.3s ease;
    filter: drop-shadow(0 1px 4px rgba(201,149,42,0.2));
  }

  &:hover img {
    transform: scale(1.06);
    filter: drop-shadow(0 2px 8px rgba(201,149,42,0.35));
  }

  @media (max-width: 768px) {
    img { height: 40px; }
    z-index: 2;
  }
`;

const MenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: ${TEXT_DARK};
  cursor: pointer;
  z-index: 2;
  padding: 0.25rem;

  @media (max-width: 768px) {
    display: block;
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;

  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    right: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
    height: 100vh;
    width: 260px;
    background: ${CREAM};
    flex-direction: column;
    padding: 5rem 2rem 2rem;
    gap: 0.5rem;
    box-shadow: -4px 0 20px rgba(201, 149, 42, 0.15);
    transition: right 0.3s ease;
    border-left: 1px solid rgba(201,149,42,0.2);
  }
`;

const NavLink = styled(Link)`
  color: ${TEXT_DARK};
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  font-family: 'Source Serif 4', serif;
  padding: 0.45rem 0.9rem;
  border-radius: 6px;
  transition: all 0.25s ease;
  position: relative;
  letter-spacing: 0.01em;

  &::after {
    content: '';
    position: absolute;
    width: 0;
    height: 1.5px;
    bottom: 2px;
    left: 50%;
    background: linear-gradient(90deg, ${GOLD}, ${GOLD_LIGHT});
    transition: all 0.28s ease;
    transform: translateX(-50%);
  }

  &:hover {
    color: ${GOLD};
    background: rgba(201, 149, 42, 0.07);

    &::after { width: 70%; }
  }

  &.active {
    color: ${GOLD};
    background: rgba(201, 149, 42, 0.08);

    &::after { width: 70%; }
  }

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
    font-size: 1.05rem;
    padding: 0.7rem 1rem;
  }
`;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const toggleMenu  = () => setIsMenuOpen(o => !o);
  const closeMenu   = () => setIsMenuOpen(false);

  return (
    <HeaderContainer>
      <Nav>
        <Logo to="/">
          <img src="/Bherilogo1.png" alt="BHERI Logo" />
        </Logo>
        <MenuButton onClick={toggleMenu} aria-label="Toggle menu">
          {isMenuOpen ? '✕' : '☰'}
        </MenuButton>
        <NavLinks isOpen={isMenuOpen}>
          <NavLink to="/dhara"    onClick={closeMenu}>Dhārā</NavLink>
          <NavLink to="/anubhuti" onClick={closeMenu}>Anubhūti</NavLink>
          <NavLink to="/abhyas"   onClick={closeMenu}>Abhyās</NavLink>
          <NavLink to="/ranjana"  onClick={closeMenu}>Rañjanā</NavLink>
          <NavLink to="/contact"  onClick={closeMenu}>Contact Us</NavLink>
        </NavLinks>
      </Nav>
    </HeaderContainer>
  );
};

export default Header;
